import React, { useState, ReactNode } from 'react'
import { connect } from 'react-redux'

import { useForTablet } from 'components/Breakpoint'
import { SidebarLayout } from 'layouts/SidebarLayout'

import { actions as sidebarActions } from 'redux/modules/documentSidebar'

export interface DocumentSidebarLayoutHeaderProps {
  isSidebarRightOpen: boolean
  toggleSidebarRight: () => void
  isSidebarLeftOpen: boolean
  setSidebarLeftOpen: React.Dispatch<React.SetStateAction<boolean>>
}

type DocumentSidebarProps = {
  title?: string
  children: ReactNode
  footer?: ReactNode
  header: React.FC<DocumentSidebarLayoutHeaderProps> | ReactNode
  isSidebarRightOpen?: boolean
  /** Navigation sidebar */
  sidebarLeft?: ReactNode
  /** Activity/inspector sidebar */
  sidebarRight?: ReactNode
  toggleSidebarRight?: () => void
  darkBackground?: boolean
}

const DocumentSidebar = ({
  isSidebarRightOpen,
  toggleSidebarRight,
  ...rest
}: DocumentSidebarProps) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)
  const isTabletAndBigger = useForTablet()
  const toggleMobileSidebar = () => setIsMobileSidebarOpen(isOpen => !isOpen)

  return isTabletAndBigger ? (
    <SidebarLayout
      isSidebarRightOpen={isSidebarRightOpen}
      toggleSidebarRight={toggleSidebarRight}
      {...rest}
    />
  ) : (
    <SidebarLayout
      isSidebarRightOpen={isMobileSidebarOpen}
      toggleSidebarRight={toggleMobileSidebar}
      {...rest}
    />
  )
}

type MapStateToProps = {
  sidebarRightOpen?: boolean
}

const mapStateToProps = (state: MapStateToProps) => ({
  isSidebarRightOpen: state?.sidebarRightOpen,
})

const mapDispatchToProps = (
  dispatch: (args: { type: string; payload: null }) => void
) => ({
  toggleSidebarRight: () => dispatch(sidebarActions.toggleSidebarRight()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DocumentSidebar)
